document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('[data-announcement-slider]')
		.forEach(initAnnouncementBar);
});

function initAnnouncementBar(announcementBarElement) {
	if (typeof Splide === 'undefined') {
		console.warn('Splide is not available.');
		return;
	}

	const options = JSON.parse(announcementBarElement.dataset.splide);
	const layout = announcementBarElement.dataset.layout;

	const splideAnnouncementBar = new Splide(announcementBarElement, options);

	if (layout === 'marquee' && window.splide?.Extensions) {
		splideAnnouncementBar.mount(window.splide.Extensions);
	} else {
		splideAnnouncementBar.mount();
	}

	if (layout !== 'slider') {
		return;
	}

	const autoplayToggleButton =
		announcementBarElement.parentElement.querySelector(
			'.announcement-bar__autoplay-toggle',
		);

	const playIcon = autoplayToggleButton?.querySelector(
		'.announcement-bar__autoplay-icon--play',
	);

	const pauseIcon = autoplayToggleButton?.querySelector(
		'.announcement-bar__autoplay-icon--pause',
	);

	const autoplayComponent = splideAnnouncementBar.Components?.Autoplay;

	if (!autoplayToggleButton || !playIcon || !pauseIcon || !autoplayComponent) {
		return;
	}

	function setAutoplayAction(nextAction) {
		const showPauseAction = nextAction === 'pause';

		autoplayToggleButton.dataset.autoplayAction = nextAction;

		autoplayToggleButton.setAttribute(
			'aria-label',
			showPauseAction ? 'Pause slideshow' : 'Play slideshow',
		);

		pauseIcon.hidden = !showPauseAction;
		playIcon.hidden = showPauseAction;

		pauseIcon.style.display = showPauseAction ? 'flex' : 'none';

		playIcon.style.display = showPauseAction ? 'none' : 'flex';
	}

	setAutoplayAction('pause');

	autoplayToggleButton.addEventListener('click', () => {
		if (autoplayToggleButton.dataset.autoplayAction === 'pause') {
			autoplayComponent.pause();
			setAutoplayAction('play');
		} else {
			autoplayComponent.play();
			setAutoplayAction('pause');
		}
	});
}
